var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noselect",attrs:{"tip":"frame-container"}},[_vm._l((_vm.columns),function(item,index){return [_vm._t("default",null,{"config":item,"index":index})]}),_vm._t("content",null,{"config":_vm.config})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }